import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { STATIC_ASSETS } from '../utils/staticAssets';

const Navigation = ({ pages, currentPage, onPageChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Logo */}
      {/* <div className="fixed top-0 left-[97px] z-50 w-[332px] h-[300px] flex items-center">
        <img
          src={STATIC_ASSETS.LOGO}
          alt="Gmatrixs Logo"
          className="w-full h-full object-contain"
        />
      </div> */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed top-8 right-8 z-50 lg:hidden bg-black/50 p-3 rounded-full"
      >
        <div className="w-6 h-6 flex flex-col justify-center space-y-1">
          <span className={`block h-0.5 bg-white transition-all ${isOpen ? 'rotate-45 translate-y-1' : ''}`}></span>
          <span className={`block h-0.5 bg-white transition-all ${isOpen ? 'opacity-0' : ''}`}></span>
          <span className={`block h-0.5 bg-white transition-all ${isOpen ? '-rotate-45 -translate-y-1' : ''}`}></span>
        </div>
      </button>
      <motion.div
        initial={{ opacity: 0, x: '100%' }}
        animate={{ 
          opacity: isOpen ? 1 : 0, 
          x: isOpen ? '0%' : '100%' 
        }}
        transition={{ duration: 0.3 }}
        className="fixed top-0 right-0 w-80 h-full bg-black/90 backdrop-blur-lg z-40 lg:hidden"
      >
        <div className="pt-20 px-8">
          {pages.map((page, index) => (
            <motion.button
              key={page.id}
              onClick={() => {
                onPageChange(index);
                setIsOpen(false);
              }}
              className={`block w-full text-left py-4 px-4 rounded-lg mb-2 transition-all duration-300 ${
                currentPage === index
                  ? 'bg-gradient-to-r from-blue-500 to-purple-600 text-white'
                  : 'text-gray-300 hover:bg-white/10'
              }`}
              whileHover={{ x: 10 }}
            >
              {page.title}
            </motion.button>
          ))}
        </div>
      </motion.div>

      {/* Mobile Overlay */}
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          className="fixed inset-0 bg-black/50 z-30 lg:hidden"
        />
      )}
    </>
  );
};

export default Navigation;